import PropTypes from 'prop-types';
import React from 'react';
import { MetricsElement } from 'react-metrics';

import StarIcon from 'modules/Common/components/svg/StarIcon';

export default function StarButton({
  hasSubscriptions = false,
  saveSubscriptions = () => {},
  deleteSubscriptions = () => {},
  trackClick = {},
  selectedTitle,
  deselectedTitle,
  hideIfDeselected = false
}) {
  if (!hasSubscriptions) {
    return (
      <MetricsElement>
        <button
          className="favourite-btn" id="favourite-btn"
          onClick={ () => saveSubscriptions() }
          { ...trackClick }
        >
          <StarIcon title={ selectedTitle } filled={ false } />
        </button>
      </MetricsElement>
    );
  } else if (!hideIfDeselected) {
    return (
      <button
        className="favourite-btn" id="favourite-btn"
        onClick={ () => deleteSubscriptions() }
      >
        <StarIcon title={ deselectedTitle } filled={ true } />
      </button>
    );
  } else {
    return null;
  }
}

StarButton.propTypes = {
  trackClick: PropTypes.object,
  selectedTitle: PropTypes.string,
  deselectedTitle: PropTypes.string,
  hideIfDeselected: PropTypes.bool,
  hasSubscriptions: PropTypes.bool,
  saveSubscriptions: PropTypes.func,
  deleteSubscriptions: PropTypes.func
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Subscriptions/StarButton.js